module.exports = __webpack_public_path__ + "img/banner-homepage.4030b9ad.png";